/* global axios */
import ApiClient from '../ApiClient';

class SocialMonitoringProfilesAPI extends ApiClient {
  constructor() {
    super('social_monitoring/profiles', {
      accountScoped: true,
      apiVersion: 'v2',
    });
  }

  toggle(id) {
    return axios.patch(`${this.url}/${id}/toggle`);
  }

  collect(id) {
    return axios.post(`${this.url}/${id}/collect`);
  }

  collectAll() {
    return axios.post(`${this.url}/collect_all`);
  }

  collectionStatus(id) {
    return axios.get(`${this.url}/${id}/collection_status`);
  }
}

export default new SocialMonitoringProfilesAPI();
